const pageId = '25092';

export default {
  pageName: 'Real-time Streaming Detail',
  pageId,
  pagePath: '/opinion/Realtime/RealtimeStreaming/Detail/:id',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    AdjustTimePeriod: {
      buttonId: `${pageId}001`,
    },
    ChangeTimePeriodType: {
      buttonId: `${pageId}002`,
    },
    AdjustTimeAxis: {
      buttonId: `${pageId}003`,
    },
    CreateAllTimeSummary: {
      buttonId: `${pageId}004`,
    },
    ViewKOLQuotes: {
      buttonId: `${pageId}005`,
    },
    ClickKeyword: {
      buttonId: `${pageId}006`,
    },
    ClickTopic: {
      buttonId: `${pageId}007`,
    },
    CreateFiltersSummary: {
      buttonId: `${pageId}008`,
    },
  },
};
